import axios from "axios";
import { SERVER_URL } from "../config";


/* ===========================
   FETCH FINANCIAL YEARS
=========================== */
export const fetchProductProfitDropdowns = async () => {
  const res = await axios.get(
    `${SERVER_URL}/productProfitabilityReport.php`,
    {
      params: {
        action: "dropdowns",
      },
    }
  );

  return res.data;
};

/* ===========================
   FETCH PRODUCT PROFIT REPORT
   Default → TOTAL GODOWNS
=========================== */
export const fetchProductProfitReport = async ({
  product = "",
  godown = "",
} = {}) => {
  const res = await axios.get(
    `${SERVER_URL}/productProfitabilityReport.php`,
    {
      params: {
        action: "report",
        product,
        godown,
      },
    }
  );

  return res.data;
};